import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import ScheduleTypeCellParamTemplateHeaderContainer from './generalData/ScheduleTypeCellParamTemplateHeaderContainer';
import ScheduleTypeCellParamTemplateDetailsContainer from './details/ScheduleTypeCellParamTemplateDetailsContainer';
import { useDirtyFieldValidation } from '@totalsoft/pure-validations-react';
import { scheduleTypeCellParamTemplateValidator } from '../../validators';
import { useQuery } from 'hooks/apollo';
import { SCHEDULE_TYPE_CELL_PARAM_TEMPLATE_QUERY, SCHEDULE_TYPE_CELL_PARAM_TEMPLATE_COLUMNS_QUERY } from '../queries';
import { useChangeTrackingLens } from '@totalsoft/change-tracking-react';
import { get, set } from '@totalsoft/change-tracking-react';

const ScheduleTypeCellParamTemplateContainer = ({ scheduleTypeCellParamTemplateId, onRedirect, canWrite }) => {
  const [lens, dirtyInfo, resetLens] = useChangeTrackingLens({});
  const [saving, setSaving] = useState(false);
  const [scheduleTypeCellParamTemplateValidation, validateScheduleTypeCellParamTemplate] = useDirtyFieldValidation(
    scheduleTypeCellParamTemplateValidator
  );

  const { loading, data } = useQuery(SCHEDULE_TYPE_CELL_PARAM_TEMPLATE_QUERY, {
    variables: { scheduleTypeCellParamTemplateId: scheduleTypeCellParamTemplateId },
    skip: !scheduleTypeCellParamTemplateId,
    onCompleted: data => {
      resetLens({
        ...data.scheduleTypeCellParamTemplate,
        scheduleTypeCellParamTemplateDetails: data.scheduleTypeCellParamTemplate.scheduleTypeCellParamTemplateDetails.map(x => ({
          selected: false,
          ...x
        }))
      });
    }
  });

  const { data: columns } = useQuery(SCHEDULE_TYPE_CELL_PARAM_TEMPLATE_COLUMNS_QUERY, {
    skip: !(lens |> get).scheduleTypeId,
    variables: { scheduleTypeId: (lens |> get).scheduleTypeId }
  });

  const onResetDetailValues = useCallback(() => {
    set(lens, {
      ...data?.scheduleTypeCellParamTemplate,
      scheduleTypeCellParamTemplateDetails:
        data?.scheduleTypeCellParamTemplate?.scheduleTypeCellParamTemplateDetails?.map(x => ({
          selected: false,
          MonthNo: x.MonthNo,
          ScheduleTypeCellParamTemplateDetailId: x.ScheduleTypeCellParamTemplateDetailId,
          scheduleTypeCellParamTemplateId: x.scheduleTypeCellParamTemplateId
        })) ?? []
    });
  }, [data?.scheduleTypeCellParamTemplate, lens]);

  return (
    <>
      <ScheduleTypeCellParamTemplateHeaderContainer
        columns={columns}
        scheduleTypeCellParamTemplateId={scheduleTypeCellParamTemplateId}
        onRedirect={onRedirect}
        lens={lens}
        dirtyInfo={dirtyInfo}
        loading={loading}
        saving={saving}
        setSaving={setSaving}
        scheduleTypeCellParamTemplateValidation={scheduleTypeCellParamTemplateValidation}
        validateScheduleTypeCellParamTemplate={validateScheduleTypeCellParamTemplate}
        canWrite={canWrite}
      />
      <ScheduleTypeCellParamTemplateDetailsContainer
        lens={lens}
        columns={columns}
        loading={loading}
        saving={saving}
        onResetDetailValues={onResetDetailValues}
        canWrite={canWrite}
      />
    </>
  );
};

ScheduleTypeCellParamTemplateContainer.propTypes = {
  scheduleTypeCellParamTemplateId: PropTypes.number,
  onRedirect: PropTypes.func,
  canWrite: PropTypes.bool.isRequired
};

export default ScheduleTypeCellParamTemplateContainer;
